<template>
    <div>
        <AdmPanel>
            <h2 slot="header_title">报告统计</h2>
            <FilterBar slot="header_buttons" :value="conditions" :condition="options.filter_rules" @search="changeQuery">
            <iv-form-item>
            <iv-button
                :disabled="loader[REPORTSTATISTICS]"
                type="info"
                @click="changeQuery()"
            >
                <iv-icon type="md-search" size="14" style="vertical-align:text-bottom"/> 查询
            </iv-button>
            </iv-form-item>
            </FilterBar>
            <iv-table
                    class="adm-table"
                    :columns="columns"
                    :loading="loader[REPORTSTATISTICS]"
                    :data="list.data">
            </iv-table>
        </AdmPanel>

        <AdmPanel>
            <h2 slot="header_title">年/社报指标录入统计</h2>
            <FilterBar slot="header_buttons" :value="conditions" :condition="options.filter_rules_input" @search="changeQueryInput">
            <iv-form-item>
            <iv-button
                :disabled="loader[INPUTSTATISTICS]"
                type="info"
                @click="changeQueryInput()"
            >
                <iv-icon type="md-search" size="14" style="vertical-align:text-bottom"/> 查询
            </iv-button>
            </iv-form-item>
            </FilterBar>
            <iv-table
                    class="adm-table"
                    :columns="columns_input"
                    :loading="loader[INPUTSTATISTICS]"
                    :data="list_input.data">
            </iv-table>
        </AdmPanel>

        <AdmPanel>
            <h2 slot="header_title">舆情指标录入统计</h2>
            <FilterBar slot="header_buttons" :value="conditions" :condition="options.filter_rules" @search="changeQuerySentiment">
                <iv-form-item>
                    <iv-button
                        :disabled="loader[SENTIMENT_STATISTICS]"
                        type="info"
                        @click="changeQuerySentiment()"
                    >
                        <iv-icon type="md-search" size="14" style="vertical-align:text-bottom"/> 查询
                    </iv-button>
                </iv-form-item>
            </FilterBar>
            <iv-table
                class="adm-table"
                :columns="sentiment_columns"
                :loading="loader[SENTIMENT_STATISTICS]"
                :data="sentimentStatisticsList.data">
            </iv-table>
        </AdmPanel>
    </div>
</template>
<script>
import AuditModel from "@/models/AuditModel";

import ModelMixin from "@/mixins/Model.mixin";
import StatusMixin from "@/mixins/Status.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";
import contact from "@/utils/contact";
import { conditioner, unique , years, getProductYear, defaultVal  } from '@/utils/';
import FilterBar from "@/components/FilterBar_X2";

const ADUIT = AuditModel.ModelName;
const INPUTSTATISTICS = 'auditinputStatistics'
const REPORTSTATISTICS = 'auditreportStatistics'
const SENTIMENT_STATISTICS = 'sentimentStatistics'
const ModelName = ADUIT;

const _years = years().map(year=>({...year, title:year.name}))

const options = {}

const filter_rules = [
    {name: 'year', type: "Select", options: _years, title: '年份', default: "", placeholder: "年份"}
]
const filter_rules_input = [
    {name: 'year_input', type: "Select", options: _years, title: '年份', default: "", placeholder: "年份"}
]

const _conditioner = conditioner(
      {//ui to url
        limit           : {type: Number, default: 10  },
        year            : {type: String , default: ""},
        year_input      : {type: String , default: ""},
      },
      {//url to ui
        limit           : {type: Number, default: 10},
        year            : {type: Number , default: ()=>getProductYear()},
        year_input      : {type: Number , default: ()=>getProductYear()},
      }
  )
function columns(vm){
  return [
      {
          title: "负责人",
          key: "userInCharge",
          align: "center",
          minWidth: 60,
      },
      {
          title: "行业",
          key: "industry",
          align: "center",
          minWidth: 60,

      },
      {
          title: "合计企业数（家）",
          key: "companyCount",
          align: "center",
          minWidth: 120,
      },
      {
          title: "报告齐全（家）",
          key: "reportCompleted",
          align: "center",
          minWidth: 150,
      },
        {
          title: "年报缺失（家）",
          key: "defectYearReport",
          align: "center",
          minWidth: 90
      },
        {
          title: "社报缺失（家）",
          key: "defectSocialReport",
          align: "center",
          minWidth: 90
      },
      {
          title: "报告齐全率",
          key: "completeRate",
          align: "center",
          minWidth: 80
      }
  ]
}
function columns_input(vm){
  return [
      {
          title: "负责人",
          key: "userInCharge",
          align: "center",
          minWidth: 60,
      },
      {
          title: "行业",
          key: "industry",
          align: "center",
          minWidth: 60,

      },
      {
          title: "合计企业数（家）",
          key: "companyCount",
          align: "center",
          minWidth: 120,
      },
      {
          title: "已录入数量（家）",
          key: "inputCompleted",
          align: "center",
          minWidth: 150,
      },
        {
          title: "未录入数量（家）",
          key: "inputIncompleted",
          align: "center",
          minWidth: 90
      },
        {
          title: "录入完成率",
          key: "inputRate",
          align: "center",
          minWidth: 90
      },
      {
          title: "录入准确率（按指标）",
          key: "accuracy",
          align: "center",
          minWidth: 80
      }
  ]
}

function sentiment_columns(vm){
    return [
        {
            title: "负责人",
            key: "userInCharge",
            align: "center",
            minWidth: 60,
        },
        {
            title: "行业",
            key: "industry",
            align: "center",
            minWidth: 60,
        },
        {
            title: "总爬取舆情数量",
            key: "sentimentCount",
            align: "center",
            minWidth: 60,
        },
        {
            title: "收录舆情数量",
            key: "includeCount",
            align: "center",
            minWidth: 60,
        },
        {
            title: "排除舆情数量",
            key: "excludeCount",
            align: "center",
            minWidth: 60,
        },
        {
            title: "数据收录率",
            key: "includeRate",
            align: "center",
            minWidth: 60,
        },
        {
            title: "进度",
            key: "completeRate",
            align: "center",
            minWidth: 60,
        },

    ]
}

export default {
        name: "statistics",
        mixins:[
            LoaderMixin(ADUIT, INPUTSTATISTICS, REPORTSTATISTICS, SENTIMENT_STATISTICS),
            StatusMixin('statistics')(['loading']),
            ModelMixin({
                contact,
                models:[
                    AuditModel
                ]
            })
        ],
        data() {
            return {
                columns: columns(this),
                columns_input: columns_input(this),
                sentiment_columns: sentiment_columns(this),
                conditions: {
                    ..._conditioner.default()
                },
                ModelName,
                ADUIT,
                INPUTSTATISTICS,
                REPORTSTATISTICS,
                SENTIMENT_STATISTICS,
                AuditModel,
                list: {
                    data: [],
                    last_page:0,
                    current_page:1
                },
                list_input: {
                    data: [],
                    last_page:0,
                    current_page:1
                },
                sentimentStatisticsList: {
                    data: [],
                    last_page:0,
                    current_page:1
                },
                options: {
                    ...options,
                    year: _years,
                    filter_rules,
                    filter_rules_input
                },
                sources:{
                    FilterBar:{
                        loading:false
                    }
                },
            }
        },
        async mounted () {
            const { query, params } = this.$route
            this.conditions = _conditioner.serialize({...query,...params}) //处理成支持UI的格式
            this.options.year = years().map(year=>({...year,title:year.name}))
            this.refreshStatistics()
            this.refreshInputStatistics()
            this.refreshSentimentStatistics()
        },
        beforeRouteUpdate(to, from, next){
            this.$nextTick(async ()=>{
                const { query, params } = to
                this.conditions = {
                    ..._conditioner.default(),
                    ..._conditioner.serialize({...query,...params}) //处理成支持UI的格式
                }
                this.refreshStatistics()
                this.refreshInputStatistics()
                this.refreshSentimentStatistics()
            })
            next();
        },
        methods: {
            async refreshStatistics(query=this.conditions){
                this.$$loading(REPORTSTATISTICS);
                this.list = await this.$$active(ModelName, 'reportStatistics', _conditioner.parse(query));
                this.list.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner.parse(query).limit + 1 : 1
                this.list.last_page = this.list.total / _conditioner.parse(query).limit
                this.$$loaded(REPORTSTATISTICS);
            },
            async refreshInputStatistics(query=this.conditions){
                this.$$loading(INPUTSTATISTICS);
                this.list_input = await this.$$active(ModelName, 'inputStatistics', _conditioner.parse(query));
                this.list_input.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner.parse(query).limit + 1 : 1
                this.list_input.last_page = this.list_input.total / _conditioner.parse(query).limit
                this.$$loaded(INPUTSTATISTICS);
            },
            async refreshSentimentStatistics(query=this.conditions){
                this.$$loading(SENTIMENT_STATISTICS);
                this.sentimentStatisticsList = await this.$$active(ModelName, 'sentimentStatistics', _conditioner.parse(query));
                this.sentimentStatisticsList.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner.parse(query).limit + 1 : 1
                this.sentimentStatisticsList.last_page = this.list_input.total / _conditioner.parse(query).limit
                this.$$loaded(SENTIMENT_STATISTICS);
            },
            pageChanged(page){
                this.$router.push({ name: this.$route.name, query: { ...this.$route.query, offset: ( page - 1 ) *  _conditioner.parse(this.conditions).limit}, params: this.$route.params });
            },
            mergeQuery(query){
              return { ...this.conditions, ...query}
            },
            changeQuery(query=this.conditions, params = this.$route.params) {
                // this.$router.push({
                //     name  : this.$route.name,
                //     query: {..._conditioner.parse(query)},
                //     params: params
                // });
                this.refreshStatistics()
            },
            changeQueryInput(query=this.conditions, params = this.$route.params) {
                // this.$router.push({
                //     name  : this.$route.name,
                //     query: {..._conditioner.parse(query)},
                //     params: params
                // });
                this.refreshInputStatistics()
            },
            changeQuerySentiment(query=this.conditions, params = this.$route.params) {
                // this.$router.push({
                //     name  : this.$route.name,
                //     query: {..._conditioner.parse(query)},
                //     params: params
                // });
                this.refreshSentimentStatistics()
            }
        },
        components:{
            FilterBar
        }
    }
</script>
<style lang="postcss" scoped>
.inline-checkList {
  display: inline-block;
  margin-right: 20px;
}
.inline-checkList >>> span {
    display: inline-block !important;
}

.inline-checkList >>> div {
  display: inline-block !important;
}
</style>
